import React, { useEffect, useRef } from 'react';
import PerfectScrollbar from 'perfect-scrollbar';

import MapTangerang from './MapTangerang';

function Dashboard() {
  const containerRef = useRef(null);

  useEffect(() => {
    let ps;

    if (containerRef.current) {
      ps = new PerfectScrollbar(containerRef.current);
    }

    return () => {
      if (ps) {
        ps.destroy();
      }
    };
  }, []);

  return (
    <>
      <div className="page-title">
        <h3>Dashboard</h3>

        <p className="text-subtitle text-muted">Monitoring Work Order dan lokasi petugas</p>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <MapTangerang />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Dashboard;
